import * as yup from "yup";
import i18n from "../../../i18n";

export const schema = yup.object().shape({
  setting_key: yup
    .string()
    .required(() => i18n.t("message:error.fieldRequired"))
    .min(1, () => i18n.t("message:error.fieldRequired")),
  setting_value: yup
    .string()
    .required(() => i18n.t("message:error.fieldRequired"))
    .min(1, () => i18n.t("message:error.fieldRequired")),
  description: yup.string().nullable(),
});

export const validateField = async (name: string, value: any) => {
  try {
    const fieldSchema = schema.fields[name];
    if (!fieldSchema) {
      return { isValid: true, error: "" };
    }
    
    const schemas = yup.object().shape({
      [name]: fieldSchema,
    });
    await schemas.validate({ [name]: value }, { abortEarly: false });
    return { isValid: true, error: "" };
  } catch (validationError) {
    return { isValid: false, error: validationError.errors[0] };
  }
};

export const validate = async (data: any) => {
  try {
    await schema.validate(data, { abortEarly: false });
    return { isValid: true, errors: {} };
  } catch (validationErrors) {
    let errors: any = {};
    validationErrors.inner.forEach((error: any) => {
      errors[error.path] = error.message;
    });
    return { isValid: false, errors };
  }
};